class MultiSelect extends HTMLElement {
  constructor() {
    super();
    this.values = [];
    this.ELM_input = this.querySelector('input[type="text"]');
    this.ELM_dropdown = this.querySelector('.multi-select-dropdown');
    this.ELM_options = this.querySelectorAll('input[type="checkbox"]');

    this.ELM_input.addEventListener('click', this.toggleDropdown.bind(this));
    document.addEventListener('click', e => {
      if (!this.contains(e.target)) this.closeDropdown();
    })
    this.ELM_options.forEach(ELM_option => {
      ELM_option.addEventListener('change', () => this.updateValue(ELM_option));
    })
  }

  updateValue(ELM_option) {
    if (ELM_option.checked) {
      this.values.push(ELM_option.value);
    } else {
      this.values = this.values.filter(value => value !== ELM_option.value);
    }
    this.ELM_input.value = this.values.join('|');
    this.ELM_input.dispatchEvent(new Event('change'));
  }

  openDropdown() {
    this.classList.add('active');
  }

  closeDropdown() {
    this.classList.remove('active');
  }

  toggleDropdown() {
    this.classList.toggle('active');
  }
}
customElements.define('multi-select', MultiSelect);

class ImageGallery extends HTMLElement {
  constructor() {
    super();

    this.ELM_mainImage = this.querySelector('[aria-main-image] img');
    this.ELM_thumbnails = this.querySelectorAll('[aria-thumbnails] .pdp-description-images-item');

    this.ELM_thumbnails?.forEach(ELM_thumbnail => ELM_thumbnail.addEventListener('click', () => {
      this.querySelector('[aria-thumbnails] .pdp-description-images-item.active')?.classList.remove('active');
      ELM_thumbnail.classList.add('active');
      const ELM_thumbnailImage = ELM_thumbnail.querySelector('img');
      this.ELM_mainImage.src = ELM_thumbnailImage.src;
      this.ELM_mainImage.setAttribute('srcset', ELM_thumbnailImage.getAttribute('srcset'));
    }))
  }
}
customElements.define('image-gallery', ImageGallery);

(function () {
  const ELM_parallaxes = document.querySelectorAll('.with-parallax');

  const parallaxScroll = () => {
    const scrollDistance = window.scrollY;
    ELM_parallaxes.forEach(elm => {
      elm.style.setProperty('--scroll-distance', `${scrollDistance}px`);
    })
  }

  if (ELM_parallaxes && ELM_parallaxes.lenth);
  window.addEventListener('scroll', parallaxScroll);
})();